import GallerySlider from "./GallerySlider";

const FramingService = () => {
  return (
    <div className="px-5 sm:px-8">
      <div
        className="wysiwyg-content font-body-regular text-sm text-black [&>*:last-child]:mb-0"
        dangerouslySetInnerHTML={{ __html: framingService?.content }}
      />
      <a
        className="font-display-bold text-xs tracking-[0.54px] text-black uppercase mt-8 underline underline-offset-4 inline-block"
        href={framingService?.cta?.link}
      >
        {framingService?.cta?.name}
      </a>
      <div className="mt-8">
        <GallerySlider gallery={framingService?.gallery} />
      </div>
    </div>
  );
};

export default FramingService;
